import React from "react";
import logo from "../../images/logo_white.png"

const LogoFooter = () => {
  return (
    <img
    className="w-[260px] h-auto -ml-8 -mt-10"
    alt="logo-orginal"
    src={logo}/>
  );
};

export default LogoFooter;
